(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/game-result.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/game-result.js');

'use strict';

svs.numbergames.results.models.GameResult = svs.numbergames.core.NumbergamesModel.extend({
  defaults() {
    return {
      productId: '',
      results: new svs.numbergames.results.collections.Results(),
      resultMonths: new svs.numbergames.results.collections.ResultMonths(),
      jackpots: undefined,
      availableDates: [],
      selectedDate: new Date()
    };
  },
  initialize() {
    this.listenTo(this, 'change:selectedDate', (model, date) => this.fetchDrawByDate(date));
    this.listenTo(this, 'datepicker:month:change', this.fetchMonth);
  },
  parse(attrs) {
    const datePicker = attrs.datePicker,
      addonDatePicker = attrs.addonDatePicker,
      result = attrs.result,
      addonResult = attrs.addonResult,
      product = attrs.product,
      jackpot = attrs.jackpot;
    const resultMonths = this.get('resultMonths');
    const results = this.get('results');
    const parsedAttrs = {
      productId: svs.numbergames.productMapping.getProductId(product),
      jackpots: new svs.numbergames.results.models.Jackpot(jackpot, {
        parse: true
      })
    };
    if (result) {
      results.add({
        result,
        addonResult
      }, {
        parse: true
      });
      parsedAttrs.selectedDate = svs.numbergames.results.parsers.datePicker.createDate(result.regCloseTime);
    }
    if (datePicker) {
      resultMonths.add({
        datePicker,
        addonDatePicker
      }, {
        parse: true
      });
      parsedAttrs.availableDates = resultMonths.getAvailableDates();
    }
    return parsedAttrs;
  },
  fetchDrawByDate(date) {
    const options = {
      context: this,
      success: draw => this.fetchResultByDraw(draw)
    };
    this.get('resultMonths').fetchDrawByDate(date, this.get('productId'), options);
  },
  getModelByDate(date) {
    date = new Date(date);
    const year = date.getFullYear();
    const month = date.getMonth();
    return this.get('resultMonths').findWhere({
      year,
      month
    });
  },
  getDrawNumberByDate(date) {
    var _dates$Date$getDate;
    const monthModel = this.getModelByDate(date);
    const dates = monthModel.get('dates');
    return (_dates$Date$getDate = dates[new Date(date).getDate()]) === null || _dates$Date$getDate === void 0 ? void 0 : _dates$Date$getDate.drawNumber;
  },
  fetchMonth(month, year) {
    let _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      context = _ref.context,
      success = _ref.success,
      error = _ref.error;
    const resultMonths = this.get('resultMonths');
    const options = {
      context: this,
      success: model => {
        this.set('availableDates', resultMonths.getAvailableDates());
        if (typeof success === 'function') success.call(context, model);
      },
      error
    };
    resultMonths.fetchMonth(month, year, this.get('productId'), options);
  },
  fetchResultByDraw(draw) {
    var _this = this;
    let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      context = _ref2.context,
      success = _ref2.success;
    const options = {
      context: this,
      success: function (model) {
        if (typeof success === 'function') success.call(context, model);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.trigger('results:change:draw', model, ...args);
      }
    };
    this.get('results').fetchResultByDraw(draw, options);
  }
});

 })(window);